<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 200px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :expand-on-click-node="false" default-expand-all></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 210px);">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>编制人：</label>
                        <el-input v-model="search_Obj.f_creator_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>审核人：</label>
                        <el-input v-model="search_Obj.f_sh_name" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>状态类型：</label>
                        <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('shstate1')" :key="'shstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="title" label="标题" sortable="custom"></el-table-column>
                        <el-table-column prop="report_date" label="报告日期" sortable="custom" width="130"></el-table-column>
                        <el-table-column prop="start_date" label="数据日期" sortable="custom">
                            <template slot-scope="scope">{{scope.row.start_date}} 至 {{scope.row.end_date}}</template>
                        </el-table-column>
                        <el-table-column prop="version" label="版本号" sortable="custom" width="130"></el-table-column>
                        <el-table-column prop="create_time" label="编制时间" sortable="custom" width="130">
                            <template slot-scope="scope">
                                <span>{{ formatDate1(scope.row.create_time, "yyyy-mm-dd") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="creator_name" label="编制人" sortable="custom" width="130"></el-table-column>
                        <el-table-column prop="sh_name" label="审核人" sortable="custom" width="130"></el-table-column>
                        <el-table-column prop="state" label="状态" sortable="custom" width="130">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.state, "shstate1") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="480" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    title="生成报告"
                    :report_type="report_type"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="1200px"
                    :id="model_id"
                    title="查看周报"
                    :isshow="infoshow"
                    @on-close="closeInfoShDialog">
                </Info>
                <InfoSh
                    width="1200px"
                    :id="model_id"
                    title="审核周报"
                    :isshow="infoshshow"
                    @on-close="closeInfoShDialog">
                </InfoSh>
                <AnnexList
                    width="600px"
                    :data_id="model_id"
                    :isshow="annexshow"
                    @on-close="closeAnnexDialog">
                </AnnexList>
                <PersonList
                    width="800px"
                    :data_id="model_id"
                    :isshow="personshow"
                    @on-close="closePersonDialog">
                </PersonList>
                <DeviceList
                    width="1000px"
                    :data_id="model_id"
                    :isshow="deviceshow"
                    @on-close="closeDeviceDialog">
                </DeviceList>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import InfoSh from "./infosh"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getTreeData } from '@/api/monthreport'
import AnnexList from "./annexlist"
import PersonList from "./personlist"
import DeviceList from "./devicelist"

export default {
    name: 'monthReportList1',
    mixins: [listutil],
    components: {Edit, Info, InfoSh, Btns, LabBtns, AnnexList, PersonList, DeviceList},
    data() {
        return {
            m_name: '周报',
            menu_id: 5110,
            list_url: "/api/admin/monthreport/list",
            search_Obj: {
                f_pid1: '',
                f_report_type: '1',
                f_report_year: '',
                f_state: '',
                f_creator_name: '',
                f_sh_name: '',
            },
            del_Obj:{
                url:'/api/admin/monthreport/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['shstate1'],
            projectDivisionData: [],
            pid: 0,
            report_type: 1,
            annexshow: false,
            personshow: false,
            deviceshow: false,
            infoshshow: false,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getTreeData().then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                }
            })
        },
        clickPrjectDivision(data){
            if(data.label =='2023' || data.label =='2024' || data.label =='2025'){
                this.search_Obj.f_report_year = data.value
                this.search_Obj.f_pid1 = data.id - 1000000 - parseFloat(data.value)
            }else{
                this.search_Obj.f_pid1 = data.id
                this.search_Obj.f_report_year = ''
            }
            this.current = 1
            this.getListData()
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(res.data.pid);
                    }, 1000);
                }
            })
        },
        annexSet(index, row){
            this.model_id = row.id
            this.annexshow = true
        },
        closeAnnexDialog(){
            this.annexshow = false
        },
        personSet(index, row){
            this.model_id = row.id
            this.personshow = true
        },
        closePersonDialog(){
            this.personshow = false
            this.getListData()
        },
        deviceSet(index, row){
            this.model_id = row.id
            this.deviceshow = true
        },
        closeDeviceDialog(){
            this.deviceshow = false
            this.getListData()
        },
        exam(index, row){
            this.model_id = row.id
            this.infoshshow = true
        },
        closeInfoShDialog(){
            this.infoshow = false
            this.infoshshow = false
            this.getListData()
        },
    }
};
</script>